<template>
    <PageView>
        <a-card title="列表">
            <a-row :gutter="10" class="inputGroup">
                <a-col :xs="12" :md="6" :lg="6" :xl="4">
                    <a-input v-model="shopName" placeholder="请输入商户名称"  />
                </a-col>
                <a-col :xs="12" :md="6" :lg="6" :xl="4">
                    <a-select allowClear v-model="searchData.status" style="width:100%" placeholder="请选择状态">
                        <a-select-option value="1">待审核</a-select-option>
                        <a-select-option value="2">通过</a-select-option>
                        <a-select-option value="-1">拒绝</a-select-option>
                    </a-select>
                </a-col>
                <a-col :xs="12" :md="6" :lg="6" :xl="4">
                    <a-range-picker v-model="time" :placeholder="['开始时间', '结束时间']" />
                </a-col>
                <a-col :xs="24" :md="24" :lg="24" :xl="24">
                    <a-button-group>
                        <a-button type="primary" :loading="loading" @click="getListTwo">确定筛选</a-button>
                    </a-button-group>
                    <a-button-group style="margin-left:10px">
                        <a-button type="primary" :loading="loading" @click="getListInit">重置</a-button>
                    </a-button-group>
                    <a-button-group>
                        <a-button style="margin-left: 10px;" type="primary" :loading="loading" @click="exportorder">导出提现记录</a-button>
                    </a-button-group>
                </a-col>
            </a-row>
            <a-table
                :loading="loading"
                :columns="columns"
                :dataSource="data"
                :pagination="{ total, pageSize, showSizeChanger, current }"
                @change="changePagination"
                bordered
                :scroll="{ x: true }"
            >
            </a-table>
        </a-card>
    </PageView>
</template>

<script type="text/jsx">
import Shop from '../../api/Shop'
import User from '../../api/User'
export default {
    name: 'admin',
    data() {
        return {
            loading: true,
            shopName:'',
            time: [],
            columns: [
                {
                    title: '店铺名称',
                    dataIndex:'shop_name',
                    customRender: (v) =>{
                      return v
                    }
                },
                {
                    title: '收款人姓名',
                    dataIndex:'name',
                    customRender: (v) =>{
                      return v
                    }
                },
                {
                    title: '收款账号',
                    dataIndex:'phone',
                    customRender: (v) =>{
                      return v
                    }
                },
                {
                    title: '金额',
                    dataIndex: 'price'
                },
                {
                    title: '状态',
                    dataIndex: 'status',
                    customRender: (v) => {
                        return v == 1 ? '待审核' : v == 2 ? '通过' : v == -1 ? '拒绝' : ''
                    }
                },
                {
                    title: '时间',
                    dataIndex: 'add_time',
                    customRender: (v) => {
                        return this.timeOne(v)
                    }
                },
                {
                    title: '操作',
                    key: 'action',
                    fixed: 'right',
                    width: 110,
                    customRender: (v) => {
                        return (
                            <a-button-group>
                                <a-button
                                    type='primary'
                                    disabled={v.status == 1 ? false : true}
                                    onClick={() => {
                                        this.changeConfig(v, 'ShopTong', '通过')
                                    }}>
                                    通过
                                </a-button>
                                <a-button
                                    type='danger'
                                    disabled={v.status == 1 ? false : true}
                                    onClick={() => {
                                        this.changeConfig(v, 'ShopJue', '拒绝')
                                    }}>
                                    拒绝
                                </a-button>

                            </a-button-group>
                        )
                    }
                }
            ],
            data: [],
            total: 0,
            pageSize: 10,
            current: 1,
            showSizeChanger: true,
            searchData: {
                username: '',
                status: undefined
            },
            levelArray: [],
            form: this.$form.createForm(this),
            confirmLoading: false,
            isShowJf: false,
            labelCol: {
                xs: { span: 24 },
                sm: { span: 6 }
            },
            wrapperCol: {
                xs: { span: 24 },
                sm: { span: 18 }
            },
            id: ''
        }
    },
    activated() {
        this.getList()
    },
    methods: {
      getListTwo(){
        this.current = 1
        this.getList();
      },
      getListInit(){
        this.time = []
        this.searchData ={
            status: undefined
        }
        this.shopName = '';
        this.getList();
      },
      exportorder(){
            User.drawExport({}).then(res => {
                if(res.status == 1){
                    window.open(res.data);
                }else{
                    this.$message.info(res.msg)
                }
            })
        },
        getList() {
            this.loading = true
             let sta = ''
            let end = ''
            if (this.time.length > 0) {
                sta = new Date(this.timeTwo(Date.parse(this.time[0]) / 1000) + ' 00:00:00').getTime()
                end = new Date(this.timeTwo(Date.parse(this.time[1]) / 1000) + ' 23:59:59').getTime()
            }
            Shop.ShopDrawlist({
                page: this.current,
                num: this.pageSize,
                ...this.searchData,
                shopName:this.shopName,
                sta_time: sta,
                end_time: end,
            }).then(res => {
                this.data = res.result.map((value, key) => {
                    return { ...value, key, isEdit: false, pwd: '' }
                })
                this.loading = false
                this.total = parseInt(res.count)
            })
        },
        changeConfigone(v) {
            this.form.resetFields()
            let data = v
            this.loading = false
            this.id = data.id
            this.isShowJf = true
            this.$nextTick(() => {
                this.form.setFieldsValue({
                    'username': data.username,
                    'pwd': data.pass,
                    'pass': data.pass,
                })

            })
        },
        changePagination(pagination) {
            Object.keys(pagination).forEach(val => {
                this[val] = pagination[val]
            })
            this.getList()
        },
        changeConfig(v, url, text) {
            this.$confirm({
                title: `${text}`,
                content: `确定要${text}吗?`,
                centered: true,
                onOk: () => {
                    return new Promise((resolve, reject) => {
                        Shop[url]({
                            id: v.id
                        }).then(res => {
                            resolve()
                            this.getList()
                        }).catch(res => {
                            reject()
                        })
                    })
                }
            })
        },
        changeGroup(id, value) {
            let group_id = value || undefined
            this.$confirm({
                title: `修改用户组`,
                width: 350,
                content: (
                    <a-select placeholder="请选择用户组" style="width:100%;margin:20px 0px 10px 0px;padding-right:38px"
                        defaultValue={group_id} onChange={(e) => {
                            group_id = e
                        }}>
                        {this.levelArray.map(v => {
                            return (<a-select-option value={v.id}>{v.title}</a-select-option>)
                        })}
                    </a-select>
                ),
                centered: true,
                onOk: () => {
                    return new Promise((resolve, reject) => {
                        Auth.changeJuese({ id, group_id }).then(res => {
                            resolve()
                            this.getList()
                        }).catch(res => {
                            reject()
                        })
                    })
                }
            })
        },
        addAdmin() {
            this.form.validateFields((err, values) => {
                if (!err) {
                    this.confirmLoading = false
                    if (this.id) {
                        Config.save_admin({ ...values, id: this.id }).then(res => {
                            this.isShowJf = false
                            this.confirmLoading = false
                            this.getList()
                        }).catch(res => {
                            this.confirmLoading = false
                        })
                    } else {
                        Config.AddAdmin(values).then(res => {
                            this.isShowJf = false
                            this.confirmLoading = false
                            this.getList()
                        }).catch(res => {
                            this.confirmLoading = false
                        })
                    }
                }
            })
        }
    }
}
</script>

<style scoped lang="less">
.inputGroup {
    > div {
        margin-bottom: 20px;
    }
}
</style>
